// extracted by mini-css-extract-plugin
module.exports = {"singleContentSection":"Section_singleContentSection__ioF6E","sectionTitle":"Section_sectionTitle__fZjNO","sectionTitleSeparator":"Section_sectionTitleSeparator__5vehF"};